import React, { useContext, useCallback } from 'react';
import Flag from 'react-flags';
import ConfigContext from '../../../contexts/ConfigContext/ConfigContext';
import GameConfigContext from '../../../contexts/GameConfigContext/GameConfigContext';
import { OptionsBox, ProfileBox, ProfileName, SettingsBox, SettingsButton } from './Options.css';

declare global {
  interface Window {
    userID: string;
  }
}

const Options = (): JSX.Element => {
  const { config, setConfig } = useContext(ConfigContext);
  const { gameConfig, setGameConfig } = useContext(GameConfigContext);

  const handleBackToMenu = useCallback(() => {
    console.log(config.user);
    setConfig({...config, openGameChooser: true, reload: !config.reload});
    setGameConfig({...gameConfig, reloaded: !gameConfig.reloaded});
  }, [config, gameConfig]);

  return (
    <OptionsBox>
      <ProfileBox>
        <Flag
          basePath="images"
          name={config.user.country}
          format="png"
          pngSize={24}
          shiny={true}
          alt=""
        />
        <ProfileName>{config.user.name}</ProfileName>
      </ProfileBox>
      <SettingsBox>
        <SettingsButton onClick={handleBackToMenu}>
          <i className="fa fa-cogs"></i>
        </SettingsButton>
      </SettingsBox>
    </OptionsBox>
  );
};

export default Options;